export default "__VITE_ASSET__CgrL$h4M__"